import { Injectable, ComponentFactoryResolver, ViewContainerRef, ViewChild } from '@angular/core';
import {SPdfViewerComponent} from './s-pdf-viewer/s-pdf-viewer.component';
import {SImgViewerComponent} from './s-img-viewer/s-img-viewer.component';

@Injectable({
  providedIn: 'root'
})
export class SFileViewerService {
  constructor(
    private componentFactoryResolver: ComponentFactoryResolver
    ) { }
    handleView(obj) {
      const {host, type, src} = obj;
      host.clear();
      let componentRef;
      if (type === 'jpeg' || type === 'jpg') {
        const imgComponentFactory = this.componentFactoryResolver.resolveComponentFactory(SImgViewerComponent);
        componentRef = host.createComponent(imgComponentFactory);
        (componentRef.instance as SImgViewerComponent).src = src;
        return;
      } else if (type === 'pdf' || type === 'word' || type === 'excel' || type === 'ppt') {
        const pdfComponentFactory = this.componentFactoryResolver.resolveComponentFactory(SPdfViewerComponent);
        componentRef = host.createComponent(pdfComponentFactory);
        (componentRef.instance as SPdfViewerComponent).src = src;
        return;
      }
    }
}
